import _ from 'lodash';
import {
    UserScopesT,
    ScopeOptionsT,
    ScopeBlockT,
    ScopeT,
} from 'business/definitions';
import { getScopeBlocks } from 'routes/Admin/UserManagement/Users/helpers';
import { snakify } from 'helpers/syntaxHelper';

export const getBlockValues = (
    field: string,
    blocks: ScopeBlockT[] | undefined,
): string[] => {
    if (!blocks || !Array.isArray(blocks)) return [];
    const filteredBlock = blocks.find(
        (blck) => snakify(blck.name) === snakify(field.split('.')[0]),
    );
    return filteredBlock ? filteredBlock.values : [];
};

const getScopeBlockNames = (scopes: ScopeT[]): string[] =>
    _(scopes)
        .map(getScopeBlocks)
        .flatten()
        .value()
        .map((block) => snakify(block.block));

const getUserScopeByField = (
    filterField: string,
    userScopes: UserScopesT,
    scopes: ScopeT[],
): UserScopesT =>
    userScopes.filter((uScope) => {
        const scopeFilteredByName = scopes.filter(
            (scp) => scp.name === uScope.name,
        );
        const blockName = getScopeBlockNames(scopeFilteredByName);
        for (const block of blockName)
            if (snakify(filterField.split('.')[0]) === block) return true;
        return false;
    });

export const hasFilterScope = (
    filterField: string,
    userScopes: UserScopesT,
    scopes: ScopeT[],
): boolean => {
    if (_.isEmpty(scopes)) return false;
    return !_.isEmpty(getUserScopeByField(filterField, userScopes, scopes));
};

const getLabelFromScopes = (scopes: ScopeT[], scopeName: string): string => {
    if (scopes) {
        const filteredScope = scopes.find((scope) => scope.name === scopeName);
        if (filteredScope) return filteredScope.label;
    }
    return '';
};

/**
Return the values of the user scopes for a given filter field
Whether the scope is restricted or not
*/
export const getScopeValuesByField = (
    field: string,
    userScopes: UserScopesT,
    t: TranslationT,
    scopes: ScopeT[],
): ScopeOptionsT[] => {
    const filteredUserScopes = getUserScopeByField(field, userScopes, scopes);
    const values = filteredUserScopes
        .map((uScope) => {
            const scopeOptions: ScopeOptionsT = {
                value: `scope:${uScope.name}`,
                label: getLabelFromScopes(scopes, uScope.name),
                section: t('common.myScopes'),
                values: [], // basic config for full access
            };
            if (uScope.accessType === 'restricted') {
                scopeOptions.values = getBlockValues(field, uScope.blocks);
            }
            return scopeOptions;
        })
        .filter((uScope) => uScope.label !== '');
    return values;
};
